module.exports = __webpack_public_path__ + "media/images/lb/800-251ca1af46226a1fcd54aef4de2593e4.svg";